import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'


export const edittableColumngroupProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
})

export type EdittableColumngroupProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumngroupProps>>>

export default defineComponent({
  name: 'OEdittableColumngroup',
  inheritAttrs: false,
  props: edittableColumngroupProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
